import { ExprUtils } from '@/common/utils/ExprUtils';

// Shared by every Property dialog: only Props with no filter, filter "ALL", or a filter matching one of the
// owner's type values (e.g. Program Type, Calc Type) are offered in the Prop picker.
export const buildPropIdFilter = (typeFilterValues) => {
  const values = (typeFilterValues ?? []).filter((value) => value != null);
  return ExprUtils.or(
    ExprUtils.notExists('filter'),
    ExprUtils.whereParams('filter', 'ALL'),
    ...values.map((value) => ExprUtils.whereParams('filter', value)),
  );
};
